import Swiper from 'swiper';
import { Navigation, Autoplay, EffectFade, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

document.addEventListener( 'DOMContentLoaded', function () {
	const swiperElements = document.querySelectorAll( '.hero__slider.swiper' );

	swiperElements.forEach( function ( element ) {
		const swiperInstance = new Swiper( element, {
			modules: [ Navigation, Autoplay, EffectFade, Pagination ],
			slidesPerView: 1,
			spaceBetween: 0,
			simulateTouch: false,
			loop: true,
			speed: 2000,
			autoplay: {
				delay: 3000,
				disableOnInteraction: true,
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: false,
			},
			pagination: {
				el: '.hero__slider-dots',
				clickable: true,
			},
			navigation: {
				nextEl: element.querySelector( '.hero__slider-arrow--right' ),
				prevEl: element.querySelector( '.hero__slider-arrow--left' ),
			},
		} );
	} );
} );

document.addEventListener( 'DOMContentLoaded', function () {
	const heroReservation = document.getElementById( 'hero-reservation' );
	const srResRoot = document.getElementById( 'sr-res-root' );

	// Перевірка, чи обидва елементи існують
	if ( ! heroReservation ) {
		return;
	}

	// Додавання обробника події
	heroReservation.addEventListener( 'click', function () {
		srResRoot.click(); // Викликаємо клік на sr-res-root
	} );
} );
